import * as React from 'react';
import SignUp from  "./auth/login";
import Appointments from "./components/insurance/appointments/appointments";
import AppointmentConfirmedProvider from "./components/provider/appointments/appointments";
import RequestProviderHistory from "./components/provider/history/request-history";
import CreateOrder from "./components/provider/createorder/createorder";


import CreateAppointment from "./components/insurance/create-appointment/create-appointment";
import ESalesQueue from './components/insurance/esalesqueue/esalesqueue';
import ErrorScreen from "./auth/errorScreen";
import { Route, HashRouter, Switch, Redirect} from "react-router-dom";
import { ProtectedRouteInsurance }  from "./router/ProtectedRouteInsurance";
import { ProtectedRouteProvider }  from "./router/ProtectedRouteProvider";
import RequestHistory from './components/insurance/history/request-history';
import DocumentsProvider from './components/provider/documents/documents';
import ClevertapReact from 'clevertap-react';

import { ProvidersAffiliateOrders } from "./constants/provider/constant";
import { ToastContainer } from "react-toast";

ClevertapReact.initialize("649-47W-Z55Z");
console.log("initialized");
function returnRole(roleId){
  switch(roleId){
    case 5432 : return 'dcadmin';
    case 5433 : return 'dcoperations';
    case 9207 : return 'insureradmin';
    case 9211 : return 'insureragent';
    case 9214 : return 'insurerbranch';
    case 9217 : return 'mareport';
    case 9219 : return 'insurercallCentre';
    default : return null;
  }
}

function App() {
  return (
    <div>
          <Switch>
            <Route exact path="/login/:token/:id/:userName" component={SignUp} />
            <Route exact path="/login" component={SignUp} />
            <Route exact path="/">
              {
                localStorage.getItem('user_details') ? <Redirect to={"/"+returnRole(JSON.parse(localStorage.getItem('user_details')).roleId)+"/appointments"} /> : <Redirect to={"/insureradmin/appointments"} />
              }
            </Route>

            <ProtectedRouteInsurance exact path="/insureradmin/appointments" component={Appointments} />
            <ProtectedRouteInsurance exact path="/insureradmin/appointments/:requestId/history" component={RequestHistory} />
            <ProtectedRouteInsurance exact path="/insureradmin/appointments/create" component={CreateAppointment} />
            <ProtectedRouteInsurance exact path="/insureradmin/appointments/esalesqueue" component={ESalesQueue} />

            <ProtectedRouteInsurance exact path="/insureragent/appointments" component={Appointments} />
            <ProtectedRouteInsurance exact path="/insureragent/appointments/:requestId/history" component={RequestHistory} />
            <ProtectedRouteInsurance exact path="/insureragent/appointments/esalesqueue" component={ESalesQueue} />

            <ProtectedRouteInsurance exact path="/insurerbranch/appointments" component={Appointments} />
            <ProtectedRouteInsurance exact path="/insurerbranch/appointments/:requestId/history" component={RequestHistory} />
            <ProtectedRouteInsurance exact path="/insurerbranch/appointments/esalesqueue" component={ESalesQueue} />

            <ProtectedRouteInsurance exact path="/insurercallCentre/appointments" component={Appointments} />
            <ProtectedRouteInsurance exact path="/insurercallCentre/appointments/:requestId/history" component={RequestHistory} />
            <ProtectedRouteInsurance exact path="/insurercallCentre/appointments/create" component={CreateAppointment} />
            <ProtectedRouteInsurance exact path="/insurercallCentre/appointments/esalesqueue" component={ESalesQueue} />
            
            <ProtectedRouteProvider exact path="/dcadmin/appointments" component={AppointmentConfirmedProvider} />
            <ProtectedRouteProvider exact path="/dcadmin/appointments/:status" component={AppointmentConfirmedProvider} />
            <ProtectedRouteProvider exact path="/dcadmin/appointments/:requestId/history" component={RequestProviderHistory} />
            <ProtectedRouteProvider exact path="/dcadmin/documents/:status" component={DocumentsProvider} />
            <ProtectedRouteProvider exact path="/dcadmin/cases/:status" component={DocumentsProvider} />
            {
              localStorage.getItem('user_details') && 
              ProvidersAffiliateOrders.includes(JSON.parse(localStorage.getItem('user_details')).providerId) && 
              <ProtectedRouteProvider exact path="/dcadmin/create/order" component={CreateOrder} />
            }
           
            <Route path="*" component={ErrorScreen} />
          </Switch>
          <ToastContainer position='bottom-right' delay={3000} />
    </div>
  );
}

export default App;
